import PropTypes from "prop-types";
import React, { useState, useEffect, useCallback } from "react";
import { Trash2 } from "react-feather";
import { useDropzone } from "react-dropzone";

const ImageUploader = ({ base64Value, setBase64Value, id = "image-uploader" }) => {
  const [fileValue, setFileValue] = useState(base64Value);
  const [imagePreview, setImagePreview] = useState(base64Value);
  // const [base64Image, setBase64Image] = useState(base64Value);

  // useEffect(() => {
  //   setFileValue(base64Value);
  //   setImagePreview(base64Value);
  //   // setBase64Image(base64Value);
  // }, [base64Value]);

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setImagePreview(reader.result);
  //       // setBase64Image(reader.result);
  //       setBase64Value(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };


  const [image, setImage] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;
      console.log("Image uploading");
      const file = acceptedFiles[0];
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);

      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        setImagePreview(result);
        // setBase64Image(result);
        setBase64Value(result);
      };
      reader.onerror = (error) => {
        console.log("Error: ", error);
      };

      reader.readAsDataURL(file);
    },
    [setBase64Value]
  );

  const removeImage = () => {
    setBase64Value("");
    setImagePreview("");
    // setBase64Image("");
    setFileValue("");
    setImage(null);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: false,
  });

  return (
    <div className="container mt-4" id={id}>
      <div
        {...getRootProps()}
        className="border border-primary border-dashed rounded p-4 text-center cursor-pointer"
        style={{ borderStyle: "dashed", cursor: "pointer" }}
      >
        <input {...getInputProps()} />
        {/* <input 
          accept="image/*"
          onChange={handleImageChange}
          className="hidden"
          name="image"
          style={{ display: "none" }}
        /> */}
        {imagePreview ? (
          <div className="position-relative">
            <img
              src={imagePreview}
              alt="Uploaded"
              className="img-fluid rounded shadow"
              // style={{ maxHeight: "300px" }}
              style={{ maxWidth: "80px", maxHeight: "80px", objectFit: "contain" }}
              
            />
            <button
              onClick={removeImage}
              type="button"
              className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
            >
              ✖
            </button>
          </div>
        ) : (
          <p className="text-muted">Drag & Drop an image or Click to Upload</p>
        )}
      </div>
    </div>
  );
};

ImageUploader.propTypes = {
  base64Value: PropTypes.string,
  setBase64Value: PropTypes.func,
  id : PropTypes.string
};

export default React.memo(ImageUploader);
